import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	rovoChatButtonLabel: {
		id: 'conversation-assistant-button.rovo-chat-label',
		defaultMessage: 'Rovo Chat',
		description: 'Label for the button that opens the conversation assistant',
	},
});
